'use strict';

module.exports = {
  template: require('./performance-review-round.html'),
  controller: require('./performance-review-round.controller'),
  controllerAs: 'vm',

  bindings: {
    data: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-round/index.js
 ** module id = 264
 ** module chunks = 0
 **/